import { openDB } from 'idb';
import { GoalSIPData } from '../models/goal-sip';

const dbPromise = openDB('goalSIP-db', 1, {
  upgrade(db) {
    db.createObjectStore('goalSIPs', { keyPath: 'id', autoIncrement: true });
  },
});

export const savegoalSIP = async (goalSIP: GoalSIPData): Promise<void> => {
  const db = await dbPromise;
  try {
    await db.add('goalSIPs', goalSIP);
  } catch (error) {
    console.error('Error saving goalSIP:', error);
    throw new Error('Could not save goalSIP.');
  }
};

export const fetchgoalSIP = async (): Promise<GoalSIPData[]> => {
  const db = await dbPromise;
  try {
    return await db.getAll('goalSIPs');
  } catch (error) {
    console.error('Error fetching goalSIP:', error);
    throw new Error('Could not fetch goalSIP.');
  }
};

export const updategoalSIP = async (id: number, updatedLoan: Omit<GoalSIPData, 'id'>): Promise<void> => {
  const db = await dbPromise;
  try {
    await db.put('goalSIPs', { id, ...updatedLoan });
  } catch (error) {
    console.error('Error updating goalSIP:', error);
    throw new Error('Could not update goalSIP.');
  }
};

export const deletegoalSIP = async (id: number): Promise<void> => {
  const db = await dbPromise;
  try {
    await db.delete('goalSIPs', id);
  } catch (error) {
    console.error('Error deleting goalSIP:', error);
    throw new Error('Could not delete GoalSIP.');
  }
};
